/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.OfferForm';

export default defineMessages({
  vehicleTypeLabel: {
    id: `${scope}.vehicleTypeLabel`,
    defaultMessage: 'Seleziona la tipologia di veicolo',
  },
  vehicleTypeCar: {
    id: `${scope}.vehicleTypeCar`,
    defaultMessage: 'Automobile',
  },
  vehicleTypeBusiness: {
    id: `${scope}.vehicleTypeBusiness`,
    defaultMessage: 'Veicolo commerciale',
  },
  vehicleTypeMinicar: {
    id: `${scope}.vehicleTypeMinicar`,
    defaultMessage: 'Minicar',
  },
  brand: {
    id: `${scope}.brand`,
    defaultMessage: 'Marca',
  },
  model: {
    id: `${scope}.model`,
    defaultMessage: 'Modello',
  },
  version: {
    id: `${scope}.version`,
    defaultMessage: 'Allestimento',
  },
  duration: {
    id: `${scope}.duration`,
    defaultMessage: 'Durata noleggio',
  },
  distance: {
    id: `${scope}.distance`,
    defaultMessage: 'Km/Anno',
  },
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: 'Anticipo €',
  },
  monthlyRate: {
    id: `${scope}.monthlyRate`,
    defaultMessage: 'Canone mensile',
  },
  services: {
    id: `${scope}.services`,
    defaultMessage: 'Eventuali servizi aggiuntivi/optional',
  },
  notes: {
    id: `${scope}.notes`,
    defaultMessage: 'Note',
  },
});
